import React, { SVGProps } from 'react';

export const EditIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.1066 4.92342L18.9965 0.81337C18.4601 0.309508 17.7572 0.0203995 17.0215 0.00103915C16.2858 -0.0183212 15.5686 0.233418 15.0065 0.708369L1.50632 14.2085C1.02146 14.6975 0.719569 15.3383 0.651311 16.0235L0.0063045 22.2786C-0.0139023 22.4983 0.0146061 22.7198 0.0897972 22.9272C0.164988 23.1346 0.285011 23.3229 0.441309 23.4786C0.581471 23.6176 0.747697 23.7276 0.930455 23.8023C1.11321 23.8769 1.30891 23.9148 1.50632 23.9136H1.64132L7.89639 23.3436C8.58159 23.2754 9.22246 22.9735 9.71141 22.4886L23.2116 8.98846C23.7355 8.43491 24.0187 7.69621 23.999 6.93424C23.9794 6.17227 23.6584 5.44918 23.1066 4.92342ZM7.62639 20.3436L3.12634 20.7636L3.53134 16.2635L12.0064 7.89345L16.0565 11.9435L7.62639 20.3436ZM18.0065 9.93347L13.9865 5.91343L16.9115 2.91339L21.0065 7.00844L18.0065 9.93347Z"
        fill="currentColor"
      />
    </svg>
  );
};
